module.exports = require('./helpers/bundle-url').getBundleURL('h9q3T') + "Rose Wallet White.0794f7e5.svg";